import { gql } from '@apollo/client';

export const SEARCH_USERS = gql`
  fragment userFromHroStaffFields on UserFromHroStaff {
    id
    netId
    department {
      id
      abbreviation
      name
    }
    hroname: name
    hroemail: email
    position
  }
  query SEARCH_USERS(
    $faculty: ID
    $department: ID
    $keyword: String
    $first: Int
  ) {
    searchUsers(
      faculty: $faculty
      department: $department
      keyword: $keyword
      first: $first
    ) {
      ... on User {
        id
        netId
        name
        email
        department {
          id
          abbreviation
          name
        }
        faculty {
          id
          abbreviation
          name
        }
        userFromHroStaff {
          ...userFromHroStaffFields
        }
      }
      ... on UserFromHroStaff {
        ...userFromHroStaffFields
      }
    }
  }
`;

export const GET_USERS = gql`
  query GET_USERS(
    $ids: [ID!]
    $state: State
    $netIds: [String!]
    $departments: [ID!]
    $keyword: String
    $first: Int
  ) {
    users(
      ids: $ids
      state: $state
      netIds: $netIds
      departments: $departments
      keyword: $keyword
      first: $first
    ) {
      id
      netId
      title
      name
      authenticationMode
      email
      faculty {
        id
        name
        abbreviation
      }
      department {
        id
        name
        abbreviation
        faculty {
          id
          name
          abbreviation
        }
        disabled
        deleted
      }
      roles {
        role {
          id
          name
          description
          disabled
          deleted
        }
        faculty {
          id
          name
          abbreviation
        }
        department {
          id
          name
          abbreviation
        }
      }
      disabled
      deleted
      lastLogin
    }
  }
`;

export const GET_USERS_WITH_PAGINATION = gql`
  query GET_USERS_WITH_PAGINATION(
    $ids: [ID!]
    $state: State
    $netId: String
    $faculty: ID
    $department: ID
    $keyword: String
    $current: Int
    $pageSize: Int
    $role: ID
  ) {
    usersWithPagination(
      ids: $ids
      state: $state
      netId: $netId
      department: $department
      faculty: $faculty
      keyword: $keyword
      current: $current
      pageSize: $pageSize
      role: $role
    ) {
      totalCount
      nodes {
        id
        netId
        title
        name
        authenticationMode
        email
        faculty {
          id
          name
          abbreviation
        }
        department {
          id
          name
          abbreviation
          faculty {
            id
            name
            abbreviation
          }
          disabled
          deleted
        }
        roles {
          role {
            id
            name
            description
            disabled
            deleted
          }
          faculty {
            id
            name
            abbreviation
          }
          department {
            id
            name
            abbreviation
          }
        }
        disabled
        deleted
        lastLogin
      }
    }
  }
`;

export const GET_USERS_FOR_SELECT_USER = gql`
  query GET_USERS_FOR_SELECT_USER(
    $ids: [ID!]
    $state: State
    $netIds: [String!]
    $departments: [ID!]
    $department: ID
    $faculty: ID
    $keyword: String
    $first: Int
  ) {
    users(
      ids: $ids
      state: $state
      netIds: $netIds
      departments: $departments
      department: $department
      faculty: $faculty
      keyword: $keyword
      first: $first
    ) {
      id
      netId
      title
      name
      faculty {
        id
        name
        abbreviation
      }
      department {
        id
        name
        faculty {
          id
          name
        }
      }
    }
  }
`;

export const GET_USER_FROM_HRO_STAFF = gql`
  query GET_USER_FROM_HRO_STAFF(
    $faculty: ID
    $department: ID
    $keyword: String
  ) {
    usersFromHroStaff(
      faculty: $faculty
      department: $department
      keyword: $keyword
    ) {
      id
      netId
      department {
        id
        name
      }
      faculty {
        id
        name
      }
      readableName
      name
      title
      email
      position
    }
  }
`;

export const ADD_USER = gql`
  mutation addUser($addUserInput: AddUserInput!) {
    addUser(input: $addUserInput) {
      id
      netId
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UPDATE_USER($updateUserInput: UpdateUserInput!) {
    updateUser(input: $updateUserInput) {
      id
      netId
      name
    }
  }
`;

export const TOGGLE_DISABLED_USER = gql`
  mutation TOGGLE_DISABLED_USER($id: ID!) {
    toggleDisabledUser(id: $id) {
      id
      netId
      name
      disabled
    }
  }
`;

export const UPDATE_USER_AUTHENTICATION_MODE = gql`
  mutation UPDATE_USER_AUTHENTICATION_MODE(
    $input: UpdateUserAuthenticationModeInput!
  ) {
    updateUserAuthenticationMode(input: $input) {
      id
      netId
      name
      authenticationMode
    }
  }
`;
